/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FertilityReproductiveHealthUpsertRequestDto
 */
export interface FertilityReproductiveHealthUpsertRequestDto {
    /**
     * Indicates whether the patient wants an assessment of fertility status
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    isInterestedFertilityStatus: boolean;
    /**
     * Indicates whether the patient is currently trying to conceive
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    isTryingToConceive: boolean;
    /**
     * Indicates whether the patient has experienced trouble conceiving in the past or currently
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    hasExperiencedTroubleConceiving?: boolean;
    /**
     * Optional details about trouble conceiving, including duration or previous diagnoses
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    troubleConceivingDetails?: string;
    /**
     * Start date of the last period in ISO 8601 date format. Stored as a QuestionnaireResponse string answer.
     * @type {Date}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    lastMenstrualPeriodStartDate?: Date;
    /**
     * Indicates whether periods are regular
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    hasRegularPeriods?: boolean;
    /**
     * Indicates whether menstrual flow is normal
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    hasNormalMenstrualFlow?: boolean;
    /**
     * Optional description when menstrual flow is not normal
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    menstrualFlowDetails?: string;
    /**
     * Indicates whether cycle timing is consistent
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    hasConsistentCycleTiming?: boolean;
    /**
     * Monthly symptoms experienced by the patient
     * @type {Array<string>}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    menstrualSymptoms?: Array<FertilityReproductiveHealthUpsertRequestDtoMenstrualSymptomsEnum>;
    /**
     * Free-text monthly symptoms not covered by the predefined list
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    otherMenstrualSymptoms?: string;
    /**
     * Symptoms related to menopause or hormonal transition
     * @type {Array<string>}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    menopauseOrHormonalTransitionSymptoms?: Array<FertilityReproductiveHealthUpsertRequestDtoMenopauseOrHormonalTransitionSymptomsEnum>;
    /**
     * Free-text menopause or hormonal transition symptoms not covered by the predefined list
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    otherMenopauseOrHormonalTransitionSymptoms?: string;
    /**
     * Indicates whether the patient is currently on HRT
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    isOnHormoneReplacementTherapy?: boolean;
    /**
     * Medication and dosage details for hormone replacement therapy
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    hormoneReplacementTherapyMedicationDetails?: string;
    /**
     * Additional free-write notes about reproductive health, libido, or energy levels
     * @type {string}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    additionalReproductiveHealthNotes?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof FertilityReproductiveHealthUpsertRequestDto
     */
    isOnboarding?: boolean;
}


/**
 * @export
 */
export const FertilityReproductiveHealthUpsertRequestDtoMenstrualSymptomsEnum = {
    MoodSwingsIrritability: 'Mood swings / Irritability',
    Bloating: 'Bloating',
    BreastTenderness: 'Breast tenderness',
    AcneBreakouts: 'Acne breakouts',
    SevereCrampingDysmenorrhea: 'Severe cramping (Dysmenorrhea)'
} as const;
export type FertilityReproductiveHealthUpsertRequestDtoMenstrualSymptomsEnum = typeof FertilityReproductiveHealthUpsertRequestDtoMenstrualSymptomsEnum[keyof typeof FertilityReproductiveHealthUpsertRequestDtoMenstrualSymptomsEnum];

/**
 * @export
 */
export const FertilityReproductiveHealthUpsertRequestDtoMenopauseOrHormonalTransitionSymptomsEnum = {
    HotFlashesOrNightSweats: 'Hot flashes or night sweats',
    VaginalDryness: 'Vaginal dryness',
    DecreasedLibidoOrPainfulSex: 'Decreased Libido or Painful Sex',
    SleepDisturbancesInsomnia: 'Sleep disturbances / Insomnia',
    BrainFogDifficultyConcentrating: 'Brain fog / Difficulty concentrating',
    ChangesInSkinAndHairHealth: 'Changes in Skin and Hair Health',
    BoneDensityChanges: 'Bone density changes'
} as const;
export type FertilityReproductiveHealthUpsertRequestDtoMenopauseOrHormonalTransitionSymptomsEnum = typeof FertilityReproductiveHealthUpsertRequestDtoMenopauseOrHormonalTransitionSymptomsEnum[keyof typeof FertilityReproductiveHealthUpsertRequestDtoMenopauseOrHormonalTransitionSymptomsEnum];


/**
 * Check if a given object implements the FertilityReproductiveHealthUpsertRequestDto interface.
 */
export function instanceOfFertilityReproductiveHealthUpsertRequestDto(value: object): value is FertilityReproductiveHealthUpsertRequestDto {
    if (!('isInterestedFertilityStatus' in value) || value['isInterestedFertilityStatus'] === undefined) return false;
    if (!('isTryingToConceive' in value) || value['isTryingToConceive'] === undefined) return false;
    return true;
}

export function FertilityReproductiveHealthUpsertRequestDtoFromJSON(json: any): FertilityReproductiveHealthUpsertRequestDto {
    return FertilityReproductiveHealthUpsertRequestDtoFromJSONTyped(json, false);
}

export function FertilityReproductiveHealthUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FertilityReproductiveHealthUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isInterestedFertilityStatus': json['isInterestedFertilityStatus'],
        'isTryingToConceive': json['isTryingToConceive'],
        'hasExperiencedTroubleConceiving': json['hasExperiencedTroubleConceiving'] == null ? undefined : json['hasExperiencedTroubleConceiving'],
        'troubleConceivingDetails': json['troubleConceivingDetails'] == null ? undefined : json['troubleConceivingDetails'],
        'lastMenstrualPeriodStartDate': json['lastMenstrualPeriodStartDate'] == null ? undefined : (new Date(json['lastMenstrualPeriodStartDate'])),
        'hasRegularPeriods': json['hasRegularPeriods'] == null ? undefined : json['hasRegularPeriods'],
        'hasNormalMenstrualFlow': json['hasNormalMenstrualFlow'] == null ? undefined : json['hasNormalMenstrualFlow'],
        'menstrualFlowDetails': json['menstrualFlowDetails'] == null ? undefined : json['menstrualFlowDetails'],
        'hasConsistentCycleTiming': json['hasConsistentCycleTiming'] == null ? undefined : json['hasConsistentCycleTiming'],
        'menstrualSymptoms': json['menstrualSymptoms'] == null ? undefined : json['menstrualSymptoms'],
        'otherMenstrualSymptoms': json['otherMenstrualSymptoms'] == null ? undefined : json['otherMenstrualSymptoms'],
        'menopauseOrHormonalTransitionSymptoms': json['menopauseOrHormonalTransitionSymptoms'] == null ? undefined : json['menopauseOrHormonalTransitionSymptoms'],
        'otherMenopauseOrHormonalTransitionSymptoms': json['otherMenopauseOrHormonalTransitionSymptoms'] == null ? undefined : json['otherMenopauseOrHormonalTransitionSymptoms'],
        'isOnHormoneReplacementTherapy': json['isOnHormoneReplacementTherapy'] == null ? undefined : json['isOnHormoneReplacementTherapy'],
        'hormoneReplacementTherapyMedicationDetails': json['hormoneReplacementTherapyMedicationDetails'] == null ? undefined : json['hormoneReplacementTherapyMedicationDetails'],
        'additionalReproductiveHealthNotes': json['additionalReproductiveHealthNotes'] == null ? undefined : json['additionalReproductiveHealthNotes'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function FertilityReproductiveHealthUpsertRequestDtoToJSON(json: any): FertilityReproductiveHealthUpsertRequestDto {
    return FertilityReproductiveHealthUpsertRequestDtoToJSONTyped(json, false);
}

export function FertilityReproductiveHealthUpsertRequestDtoToJSONTyped(value?: FertilityReproductiveHealthUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isInterestedFertilityStatus': value['isInterestedFertilityStatus'],
        'isTryingToConceive': value['isTryingToConceive'],
        'hasExperiencedTroubleConceiving': value['hasExperiencedTroubleConceiving'],
        'troubleConceivingDetails': value['troubleConceivingDetails'],
        'lastMenstrualPeriodStartDate': value['lastMenstrualPeriodStartDate'] == null ? undefined : ((value['lastMenstrualPeriodStartDate']).toISOString().substring(0,10)),
        'hasRegularPeriods': value['hasRegularPeriods'],
        'hasNormalMenstrualFlow': value['hasNormalMenstrualFlow'],
        'menstrualFlowDetails': value['menstrualFlowDetails'],
        'hasConsistentCycleTiming': value['hasConsistentCycleTiming'],
        'menstrualSymptoms': value['menstrualSymptoms'],
        'otherMenstrualSymptoms': value['otherMenstrualSymptoms'],
        'menopauseOrHormonalTransitionSymptoms': value['menopauseOrHormonalTransitionSymptoms'],
        'otherMenopauseOrHormonalTransitionSymptoms': value['otherMenopauseOrHormonalTransitionSymptoms'],
        'isOnHormoneReplacementTherapy': value['isOnHormoneReplacementTherapy'],
        'hormoneReplacementTherapyMedicationDetails': value['hormoneReplacementTherapyMedicationDetails'],
        'additionalReproductiveHealthNotes': value['additionalReproductiveHealthNotes'],
        'isOnboarding': value['isOnboarding'],
    };
}

